import COMPANY_API from '@/api/masterData/company.js';

export const searchCells = (ctx) => {
  return [
    {
      prop: 'platformCompanyCode',
      name: '平台公司',
      type: 'select',
      value: 'personCompanyCode',
      label: 'personCompanyName',
      options: JSON.parse(ctx.userInfo.userInfo.companyList),
      clearable: false,
      filterable: true,
      changeMethod: 'changeMethod',
    },
    {
      prop: 'contractBusinessDepartmentNo',
      name: '申请部门',
      type: 'ajaxSelect',
      apiUrl: COMPANY_API.GET_DEPARTMENT_LIST_API,
      apiData: {
        belongCompanyCode: ctx.query.platformCompanyCode,
        tenantCode: ctx.userInfo.userInfo.tenantCode,
      },
      clearable: false,
      filterable: true,
      disabled: !ctx.query.platformCompanyCode,
      valueKey: 'createDepartmentCode',
      labelKey: 'createDepartmentName',
      valueType: 'object',
      method: 'post',
      changeMethod: 'changeMethod',
    },
    {
      prop: 'customerNo',
      name: '应收款单位',
      type: 'searchTableSpec',
      isMultiple: true,
      searchType: 'partner',
      extraData: {
        companyCode: ctx.userInfo.userInfo.companyCode,
        // departmentCode: ctx.query.contractBusinessDepartment,
        partnerTypes: 'HZHB01,HZHB02,HZHB03',
      },
      changeMethod: 'changeMethod',
    },
    {
      prop: 'projectInitiationNo',
      name: '立项编号',
      searchType: 'projectListWumaoByPage',
      type: 'searchTableSpec',
      isMultiple: true,
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05'],
        applyDepartmentNo: ctx.query.applyDepartmentNo
          ? ctx.query.contractBusinessDepartmentNo
          : ctx.userInfo.userInfo.departmentCode,
        businessGroup: ctx.userInfo.userInfo.businessGroup,
        platformtCompanyList: ctx.query.platformCompanyCode
          ? [ctx.query.platformCompanyCode]
          : [ctx.userInfo.userInfo.companyCode],
      },
      changeMethod: 'changeMethod',
    },
    {
      name: '合同编号',
      prop: 'contractNoLike',
      type: 'searchTableSpec',
      searchType: 'wumaoContract',
      extraData: {
        contractCategory: 'sales',
        companyCode: ctx.query.platformCompanyCode,
        departmentCode: ctx.query.contractBusinessDepartmentNo,
      },
      changeMethod: 'changeMethod',
      isMultiple: true,
    },
    // {
    //   prop: 'saleInvoiceNo',
    //   name: '销售发票编号',
    //   type: 'searchTableSpec',
    //   searchType: 'contract',
    //   extraData: {
    //     contractCategory: 'sales',
    //     companyCode: ctx.query.platformCompanyCode,
    //     departmentCode: ctx.query.applyDepartmentCode,
    //   },
    //   changeMethod: 'changeMethod',
    //   isMultiple: true,
    // },
    // {
    //   type: 'date',
    //   prop: 'invoiceDate',
    //   format: 'yyyy-MM-dd',
    //   name: '开票日期',
    // },
    // {
    //   type: 'date',
    //   prop: 'dispatchDate',
    //   format: 'yyyy-MM-dd',
    //   name: '发货日期',
    // },
  ];
};

// 表格列
export const defaultColumns = [
  {
    field: 'platformCompanyName',
    title: '平台公司',
    width: 180,
  },
  {
    field: 'contractBusinessDepartmentName',
    title: '申请部门',
    width: 180,
  },
  {
    field: 'projectName',
    title: '立项名称',
    width: 180,
  },
  {
    field: 'projectInitiationNo',
    title: '立项编号',
    width: 180,
  },
  {
    field: 'contractNo',
    title: '合同编号',
    width: 180,
  },
  {
    field: 'customerName',
    title: '应收款单位',
    width: 180,
  },
  {
    field: 'settlementDateName',
    title: '结算日',
    width: 180,
  },
  {
    field: 'invoiceCode',
    title: '销售发票编号',
    width: 180,
  },
  {
    field: 'invoiceDate',
    title: '开票日期',
    width: 180,
  },
  {
    field: 'deliveryDate',
    title: '发货日期',
    width: 180,
  },
  {
    field: 'invoicedAmount',
    title: '开票金额',
    width: 180,
  },
  {
    field: 'returnedDate',
    title: '应回款日期',
    width: 180,
  },
  {
    field: 'allocationAmount',
    title: '已回款金额',
    width: 180,
  },
  {
    field: 'overdueAmount',
    title: '逾期金额',
    width: 180,
  },
  {
    field: 'overdueDays',
    title: '逾期天数',
    width: 180,
  },
];
